import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        console.log(savedPosition)
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [{
            path: '/fillIndex',
            name: 'inquiry',
            meta: { keepAlive: false, title: '快速问诊' },
            component: () =>
                import ('./views/inquiry_index.vue')
        },
        {
            path: '/fill',
            name: 'fill',
            // meta:{requireAuth:true},
            meta: {
                title: "我要问诊"
            },
            component: () =>
                import ('./views/fill-inquiry-information.vue')
        },
        {
            path: '/sweep_code_results',
            name: 'sweep_code_results',
            // meta:{requireAuth:true},
            meta: {
                title: "扫码结果"
            },
            component: () =>
                import ('./views/sweep_code_results.vue')
        },

        {
            path: '/medicine',
            name: 'medicine',
            meta: {
                title: "药品搜索"
            },
            component: () =>
                import ('./views/add_medicine.vue')
        },
        {
            path: '/myConsultation',
            name: 'myConsultation',
            meta: { keepAlive: true, title: "问诊记录" },
            component: () =>
                import ('./views/my-consultation.vue')

        },

        {
            path: '/prescriptionDetail',
            name: 'prescriptionDetail',
            meta: {
                title: "处方详情"
            },
            component: () =>
                import ('./views/prescription-detail.vue')
        },
        {
            path: '/inquiryDetail',
            name: 'inquiryDetail',
            meta: {
                title: "问诊详情"
            },
            component: () =>
                import ('./views/inquiry-detail.vue')
        },
        // {
        // 	path: '/addDrug',
        // 	name: 'adddrug',
        // 	meta: {
        // 		title: "药品添加"
        // 	},
        // 	component: () => import('./views/add-drug.vue')
        // },
        {
            path: '/addDisease',
            name: 'addDisease',
            component: () =>
                import ('./views/add-disease.vue')
        },
        {
            path: '/prescription',
            name: 'prescription',
            meta: {
                title: "查看处方"
            },
            component: () =>
                import ('./views/prescription_image.vue')
        },

        {
            path: '/doctorList',
            name: 'doctorList',
            meta: {
                title: "医生列表",
                keepAlive: true
            },
            component: () =>
                import ('./views/doctor-list.vue'),
        },
        {
            path: '/doctorDetails',
            name: 'doctorDetails',
            meta: {
                title: "医生详情"
            },
            component: () =>
                import ('./views/doctor-list-detail.vue')
        },
        {
            path: '/protocol',
            name: 'protocol',
            meta: {
                title: "知情同意书"
            },
            component: () =>
                import ('./views/protocol.vue')
        },
        {
            path: '/seeImage',
            name: 'seeImage',
            meta: {
                title: "图片预览"
            },
            component: () =>
                import ('./views/seeImage.vue')
        },
        {
            path: '/signature',
            name: 'signature',
            meta: {
                title: "药师签名"
            },
            component: () =>
                import ('./views/signature_entry.vue')
        },
        {
            path: '/signature_entry',
            name: 'signature_entry',
            meta: {
                title: "药师签名"
            },
            component: () =>
                import ('./views/SF_signature_entry.vue')
        },
        {
            path: '/mobilePayment',
            name: 'mobilePayment',
            meta: {
                title: "支付"
            },
            component: () =>
                import ('./views/mobile_payment.vue')
        },
        {
            path: '/mobilePaymentSuccess',
            name: 'mobilePaymentSuccess',
            meta: {
                title: "支付成功"
            },
            component: () =>
                import ('./views/mobile_payment_success.vue')
        },
        {
            path: '/interviewRecordSearch',
            name: 'interviewRecordSearch',
            meta: {
                title: "问诊搜索",
                keepAlive: true
            },
            component: () =>
                import ('./views/interview-record-search.vue')
        },
        {
            path: '/appComingContinued',
            name: 'appComingContinued',
            meta: {
                title: "续方"
            },
            component: () =>
                import ('./views/app_coming_continued.vue')
        },
        {
            path: '/historyPerson',
            name: 'historyPerson',
            meta: {
                title: "历史用药人"
            },
            component: () =>
                import ('./views/history_person.vue')
        },
        {
            path: '/prescriptionRecord',
            name: 'prescriptionRecord',
            meta: {
                title: "药师审方",
                keepAlive:true
            },
            component: () =>
                import ('./views/prescription_record.vue')
        },
        {
            path: '/buyInquiry',
            name: 'buyInquiry',
            meta: {
                title: "购买套餐",
                keepAlive: true
            },
            component: () =>
                import ('./views/buy_inquiry.vue')
        },
        {
            path: '/protocolApp',
            name: 'protocolApp',
            meta: {
                title: "APP用户协议"
            },
            component: () =>
                import ('./views/protocol_app.vue')
        },
        {
            path: '/openPharmacist',
            name: 'openPharmacist',
            meta: {
                title: "完善药师信息",
                keepAlive:true
            },
            component: () =>
                import ('./views/open_pharmacist.vue')
        },
        {
            path: '/setSignature',
            name: 'setSignature',
            meta: {
                title: "签名设置",
                keepAlive:true
            },
            component: () =>
                import ('./views/set_signature.vue')
        },
        {
            path: '/start',
            name: 'start',
            meta: {
                title: "申请开通店铺"
            },
            component: () =>
                import ('./views/start.vue')
        },
        {
            path: '/testtt',
            name: 'testtt',
            meta: {
                title: "申请开通"
            },
            component: () =>
                import ('./views/testtt.vue')
        },


    ]
})